import PhysiologySprintRepository from '@/shared/http/repositories/socialProject/physiology-sprint'
import { IsSuccessCode } from '@/shared/utils/API'
import { loading } from '@/shared/utils/UIHelper'
import VueHighcharts from 'vue2-highcharts'

export default {
  components: {
      VueHighcharts
  },

  props: {
    physiologyId: {
      type: String,
      default: {}
    }
  },

  data: () => ({
    options: {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Rendimento da Turma'
      },
      subtitle: {
        text: 'Tempo Total(s)'
      },
      xAxis: {
        type: 'category',
        labels: {
            rotation: -45,
            style: {
                color: '#0d75a3',
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif'
            }
        }
      },
      yAxis: {
        min: 0,
        title: {
            text: 'Tempo Total(s)'
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        pointFormat: 'Tempo dê: <b>{point.y:.1f}(s)</b>'
      },
      series: [{
        name: 'Médias',
        dataLabels: {
            enabled: true,
            rotation: -90,
            color: '#FFFFFF',
            align: 'right',
            format: '{point.y:.1f}', // one decimal
            y: 10, // 10 pixels down from the top
            style: {
                fontSize: '13px',
                fontFamily: 'Verdana, sans-serif',
            }
        }
      }]
    }
  }),

  watch: {
    physiologyId: {
      handler: function (value) {
        if (value) {
          this.loadChargeData(value)
        }
      },
      immediate: true
    }
  },

  methods: {
    loadChargeData(id) {
      loading.push()
      PhysiologySprintRepository.GetPhysiologySprintByPhysiologyId(id)
      .then(response => {

        if(!IsSuccessCode){
          return Promise.reject()
        }

        const student = response.data.data

        let studentName = []
        let studentTotalTimeAverage = []
        let orderDescBySprint = []
        let classAverage = 0
        
        if (student.length != 0) {
          orderDescBySprint = student.sort(function(a,b) {return b.totalTime - a.totalTime;})
          studentName = orderDescBySprint.filter(sn => sn.totalTime != null).map(sn => sn.studentName)
          studentTotalTimeAverage = orderDescBySprint.filter(sn => sn.totalTime != null).map( sn => sn.totalTime)
          classAverage = studentTotalTimeAverage.reduce((value1, value2) => value1 + value2, 0) / studentTotalTimeAverage.length
          this.$emit('classAverageTotalTime', Number(parseFloat(classAverage).toFixed(1)))
          
          studentName.push('MÉDIA DA TURMA')
          studentTotalTimeAverage.push(classAverage)

          studentName.push('LITERATURA')
          studentTotalTimeAverage.push(student[0].sprintLiterature)
        }

        setTimeout(() => {
          this.$refs.lineCharts.chart.update({
            xAxis: {
              categories: studentName,
              text: null
            },
            series: [{
              name: 'Média',
              data: studentTotalTimeAverage
            }],
            title: {
              text: 'Rendimento da Turma',
              align: 'center'
            },
            subtitle: {
              text: 'Tempo Total em Segundos',
              align: 'center'
            }
          })

          loading.pop()
        }, 1300)
      })
      .catch(e => {
        loading.pop()
        console.log(`Erro ao tentar obter os dados para o gráfico de rendimentos da turma: \n ${e}`)
      })
    }
  }
}